module.exports = __webpack_public_path__ + "static/media/mapa.902a05f9.png";